/**
 * Helpers for the FranceConnect manual-linking flow.
 *
 * The SPA drops a short-lived signal cookie on `.engie.fr` before
 * launching the DB login transaction. ACUL reads it here to render the
 * intermediate "Link FranceConnect to your ENGIE account" screen.
 */

export const FRANCE_CONNECT_LINK_COOKIE_NAME = 'engie_franceconnect_link';

/** Domain the SPA scopes the signal cookie to. */
const FRANCE_CONNECT_LINK_COOKIE_DOMAIN = 'engie.fr';

/**
 * Returns true when the FranceConnect-linking signal cookie is present.
 * Safe to call at SSR time (returns false).
 */
export function isFranceConnectLinkFlow(): boolean {
  if (typeof document === 'undefined') return false;

  const cookies = document.cookie.split(';');
  return cookies.some((c) => {
    const [rawName, rawValue] = c.split('=');
    return (
      rawName?.trim() === FRANCE_CONNECT_LINK_COOKIE_NAME &&
      rawValue?.trim() === '1'
    );
  });
}

/**
 * Delete the signal cookie once it has been consumed so it cannot leak
 * into a subsequent, unrelated transaction.
 */
export function clearFranceConnectLinkCookie(): void {
  if (typeof document === 'undefined') return;

  const host = window.location.hostname;
  const parts = [
    `${FRANCE_CONNECT_LINK_COOKIE_NAME}=`,
    'path=/',
    'max-age=0',
    'SameSite=Lax',
  ];

  if (host.endsWith(FRANCE_CONNECT_LINK_COOKIE_DOMAIN)) {
    parts.push(`Domain=.${FRANCE_CONNECT_LINK_COOKIE_DOMAIN}`);
  }
  if (window.location.protocol === 'https:') parts.push('Secure');

  // biome-ignore lint/suspicious/noDocumentCookie: @TODO: This has to be updated to use the cookie store from the SPA developments.
  document.cookie = parts.join('; ');
}
